import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import { Link } from 'react-router-dom';

class MyGrads extends ChemComponent {
  	constructor(props) {
		super(props);
		
		this.state = {
			renderKey: 1,
			search: {
				STUDENT_NAME: null
			},
			gradList: this.mergeObject(gradList, { ajax: { data: { personid: props.user.personID } } })
		};
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		// update state
		this.mergeState({
			gradList: {
				renderKey: this.state.gradList.renderKey + 1,
				ajax: {
					data: {
						studentname: this.state.search.STUDENT_NAME
					}
				}
			},
		}, () => {
			if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
		});
	}
	
	render() {
		return (<>
			<Container fluid>
				<Row>
					<Col>
					  <Container>
					    <Row>
						  <Col xs={10} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
							<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Graduate Students</span>
					        <ChemEdit parent={this} columns={gradListSearchColumns} data={this.state.search} renderKey={this.state.key} 
						      onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
							  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						        <Col xs={12}>
					              <Button id="update" variant="warning" type="submit" className="float-end">Update</Button>
								</Col>
							  </Form.Group>
					        </ChemEdit>
					      </Col>
						</Row>
					  </Container>
					</Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.gradList.renderKey} parent={this} name='BuildingAccess_GradList' table={this.state.gradList} offsetHeight='230px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const gradListSearchColumns = [
	{ Header: 'Name', accessor: 'STUDENT_NAME' }
];

const gradList = {
	renderKey: 0,
	pageSize: 10,
	ajax: { 
		url: '/BuildingAccess/GetGrads',
		data: {
			personid: null,
			studentname: null
		},
		accessor: 'Grads'
	},
	columns: [
		{ Header: 'PERSON_ID', accessor: 'PERSON_ID', show: false },
		{ Header: 'Name', accessor: 'STUDENT_NAME',
			Cell: props => <Link to={'/BuildingAccess/People/' + props.row.values.PERSON_ID}>{props.value}</Link> },
		{ Header: 'Email', accessor: 'EMAIL' },
		{ Header: 'Location', accessor: 'LOCATION' },
		{ Header: 'Start Date', accessor: 'START_DATE' },
		{ Header: 'PI', accessor: 'PI_NAME' },
		{ Header: 'Cal1 Card', accessor: 'CARD_ID' },
		{ Header: () => <>Stores<br/>Checkout</>, accessor: 'STORES_ACCESS' },
		{ Header: () => <>Default<br/>Speedtype</>, accessor: 'SPEEDTYPE' },
		{ Header: () => <>Expected<br/>Departure</>, accessor: 'END_DATE' }
	]
};

export default MyGrads;
